import { watch } from 'vue'
import { setLocale as setVeeValidateLocale } from '@vee-validate/i18n'
import { useUserStore } from '~/stores/useUserStore'
import { mapUserLanguageToI18nLocale } from '~/utils/mapUserLanguageToI18nLocale'
import { inferUiLocaleFromNavigator } from '~/utils/inferUiLocaleFromNavigator'
import { syncDocumentLangFromUserPrefs } from '~/utils/syncDocumentLang'

export default defineNuxtPlugin({
  name: 'i18n-user-sync',
  enforce: 'post',
  setup() {
    const userStore = useUserStore()
    const nuxtApp = useNuxtApp()
    const i18n = nuxtApp.$i18n

    function resolveCode(): 'de' | 'en' {
      const lang = userStore.language?.trim()
      if (lang) return mapUserLanguageToI18nLocale(lang)
      return inferUiLocaleFromNavigator()
    }

    function apply() {
      const code = resolveCode()
      i18n?.setLocale?.(code)
      setVeeValidateLocale(code)
      syncDocumentLangFromUserPrefs(
        userStore.language?.trim() || (code === 'en' ? 'en' : 'de'),
        userStore.locale,
      )
    }

    watch(
      () => [userStore.language, userStore.locale] as const,
      apply,
      { immediate: true },
    )
  },
})
